import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="sendmail">
                1.&nbsp;<span className="material-symbols-outlined">send</span>&nbsp;{translate('sendmail')}
            </Typography>
            <p><strong>{translate('sendmail')}</strong> là một hành động gửi email bằng Gmail API. Tính năng này cho phép người dùng gửi email từ tài khoản Gmail của họ.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Gmail được sử dụng để xác định tài khoản email (xem <Box component={Link} to="/control-center/documentation/connections/gmail">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}</td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ người gửi email. Bạn có thể sử dụng các địa chỉ đã được thêm vào tài khoản của mình từ cài đặt Gmail (xem <a href='https://support.google.com/mail/answer/22370' target="_blank">tại đây</a> để biết cách thêm chúng).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ sẽ gửi email đi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('subject')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tiêu đề của email.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('body')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nội dung của email.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('attachments')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn tệp để đính kèm vào email. Bạn cũng có thể chỉ định nhiều tệp (các đường dẫn cách nhau bởi dấu phẩy).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('cc')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ gửi trong CC. Bạn cũng có thể chỉ định nhiều địa chỉ và địa chỉ được đặt tên.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('bcc')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ gửi trong BCC. Bạn cũng có thể chỉ định nhiều địa chỉ và địa chỉ được đặt tên.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>john.doe@example.com</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('subject')}</span>
                            <div>Hello! John!</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('body')}</span>
                            <div>Hi John, I'm very happy to send this mail to you.</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getgmail">
                2.&nbsp;<span className="material-symbols-outlined">mark_email_unread</span>&nbsp;{translate('getgmail')}
            </Typography>
            <p><strong>{translate('getgmail')}</strong> là một một hành động truy xuất email từ tài khoản Gmail dành cho Google Workspace của bạn.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$gmailMessages_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Gmail được sử dụng để xác định tài khoản email (xem <Box component={Link} to="/control-center/documentation/connections/gmail">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('query')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là điều kiện tìm kiếm (xem <a href='https://support.google.com/mail/answer/7190' target="_blank">tại đây</a> để biết chi tiết về các điều kiện tìm kiếm).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('limit')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là số lượng email tối đa truy xuất.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('markasread')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động đánh dấu đã đọc thư, nếu công tắc <strong>{translate('markasread')}</strong> được bật (true) thì sau khi truy xuất tất cả các thư trùng khớp với điều kiện tìm kiếm sẽ được đánh dấu đã đọc.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$gmailMessages_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('query')}</span>
                            <div>from: john.doe@example.com</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('markasread')}</span>
                            <div>true</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            {
                                                "id": "123456789abcdefg",
                                                "subject": "Hello! Me!",
                                                "to": "me <me@gmail.com>",
                                                "cc": "aaa <aaa@gmail.com>",
                                                "from": "bbb <bbb@gmail.com>",
                                                "date": "2023-01-14T10:41:09.000Z",
                                                "body": "Nice to meet you!",
                                                "html": "",
                                                "attachements": [
                                                {
                                                    "filename": "combine.pdf",
                                                    "contentType": "application/octet-stream",
                                                    "attachmentId": "ANGjdJ8xf--nLYOiblQaphB0PPmxwiHzqWb189HnjTBSsfYaIEDtgYj2ERCLNrDwMw_okMmC6yPCsip0rHRTvzwH7PbjuEd7TPE1mkYHPANdMCd0K8BU9kNEwR0AEKfw8JFPuHlxcTznvBBVlyjXfdMdjtrRSYRKPKwD-sqRZL0mleYM5TARSDLLKFVl0rhlMNFhvnFwUCLQPx_EmrHByTu2iZOQqDFLwF2gPuAvsvz3qc_ZmrCMs6A825NfRcniz0AzcNvDaCEEAMjbrif6hzOVqnaT1wBeBw-uRX9KxiFLquwuxW3-GI6oRROSG5QdzuzuvCUzcaK4vqxCaGzcDil0OjOOgbYBKCEZMXjKpGfeSq416VpQcj4t3YCaO0c8mfjP7MbwkHxmAS7wT8kGUSMI_0icEtmHKuQNwy3dgQ"
                                                },
                                                {
                                                    "filename": "image.png",
                                                    "contentType": "image/png",
                                                    "attachmentId": "ANGjdJ9A5SjcD6C0B3vB-DKy5bt7b8FxTPJpnAVwJ7KmtZ3bPRH8vYyM8XbWqUbNGLvGveHo0f4B0ucUiyTTV1zLRRQigFPTTHtdxE4rZodBQQjvQng3Fnyv82Z8H7rlyA2ST8eXP4sEvaWuJy16Gs8qS_QNVME86VLkSllif19xEwddOK3fM2WXmCG8A8kGdOl1W8xHpJ44wAVgzjxn1ah2VbxKbS-HEjx9n-kZ70rtlIKBlRl-5Nhr2MrifV4LtTvSx6Z-14Iw7RmECkB4PC6fHQk7CseD3z6x3aa4oRDygNeAwakSHbYq-FFajw1elYkCfG6b6t8sIEslCvNHERw8J3JiQfdcWE6QSoXkCSsp56xrkAsS4W__iQQ3hxR1iehbMu_h1rPTw4oANJ3R"
                                                }
                                                ]
                                            }
                                        ], null, 2)}
                                </pre>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gmaildownloadattachments">
                3.&nbsp;<span className="material-symbols-outlined">attach_email</span>&nbsp;{translate('gmaildownloadattachments')}
            </Typography>
            <p><strong>{translate('gmaildownloadattachments')}</strong> là một hành động tải tất cả các tệp có trong kết quả của <strong>{translate('getgmail')}</strong> (tệp tải về được lưu trong kho lưu trữ).</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$gmailAttachments_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Gmail được sử dụng để xác định tài khoản email (xem <Box component={Link} to="/control-center/documentation/connections/gmail">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('gmailmessages')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">data_array</span>
                                        <span>{translate('datatype__array')}</span>
                                    </div>
                                </td>
                                <td>Là kết quả của <strong>{translate('getgmail')}</strong>.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$gmailAttachments_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('gmailmessages')}</span>
                            <div>$gmailMessages_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf",
                                            "/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/image.png",
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);